import React from "react";
import "./FormSection.scss";

const FormSection = ({ children, title, action }) => (
  <div className="FormSection">
    <div className="title" data-action={action ? true : false}>
      <h4>{title}</h4>
      {action}
    </div>
    <div className="content">{children}</div>
  </div>
);

export default FormSection;
